<div class="breadcrumb-container flex flex-row justify-between">
  <div class="flex flex-col breadcrumb-text">
    <span class="breadcrumb-title" *ngIf="!useCustomTitle">
      <span class="patient-name">{{ patientName }}</span
      ><span class="patient-details">{{ patientDetails }}</span>
    </span>
    <div class="breadcrumb-title-content" *ngIf="useCustomTitle">
      <ng-content select="[breadcrumb-title]"></ng-content>
    </div>

    <nav aria-label="breadcrumb">
      <ol class="breadcrumb-list">
        <li *ngIf="path" class="breadcrumb-item">
          <a href="#">{{ path }}</a>
        </li>
        <li *ngIf="station" class="breadcrumb-item">{{ station }}</li>
        <li *ngIf="filter" class="breadcrumb-item">{{ filter }}</li>
      </ol>
    </nav>
  </div>

  <div class="breadcrumb-controls">
    <ng-content></ng-content>
  </div>

  <app-logo class="breadcrumb-logo"></app-logo>
</div>
